import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-point-summary" }
const _hoisted_2 = { class: "p-form-group" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-form-group" }
const _hoisted_5 = { class: "p-the-j-input-screen__point" }
const _hoisted_6 = {
  key: 0,
  class: "p-the-j-input-screen__point__col"
}
const _hoisted_7 = { class: "p-the-j-input-screen__point__input" }
const _hoisted_8 = {
  class: "p-the-j-input-screen__point__unit",
  "data-translate-skip": ""
}
const _hoisted_9 = {
  key: 1,
  class: "p-the-j-input-screen__point__note"
}
const _hoisted_10 = { "data-translate-skip": "" }
const _hoisted_11 = {
  key: 2,
  class: "p-the-j-input-screen__point__col"
}
const _hoisted_12 = { class: "p-the-j-input-screen__point__select" }
const _hoisted_13 = {
  class: "p-the-j-input-screen__point__unit",
  "data-translate-skip": ""
}
const _hoisted_14 = {
  key: 3,
  class: "p-the-j-input-screen__point__col"
}
const _hoisted_15 = { class: "p-the-j-input-screen__point__text" }
const _hoisted_16 = {
  class: "p-the-j-input-screen__point__unit",
  "data-translate-skip": ""
}
const _hoisted_17 = { class: "p-form-group" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "p-cmt"
}
const _hoisted_20 = { class: "p-form-group" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "p-form-button-group" }
const _hoisted_23 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PointNotation = _resolveComponent("PointNotation")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputTextarea = _resolveComponent("InputTextarea")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.formSchema)
    ? (_openBlock(), _createBlock(_component_Form, {
        key: 0,
        "validation-schema": _ctx.formSchema,
        "initial-values": _ctx.initialValues,
        onSubmit: _ctx.submit,
        ref: "nativeForm",
        class: "p-the-j-input-screen"
      }, {
        default: _withCtx(({ meta }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "p-the-j-input-screen__label" }, " 贈与可能ポイント ", -1)),
              _createVNode(_component_PointNotation, {
                "font-size": 24,
                point: _ctx.thanksExclusivePoint,
                "sign-is-exists": false
              }, null, 8, ["point"])
            ]),
            (_ctx.showUsedPoints)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "p-the-j-input-screen__label" }, " 合計送付ポイント ", -1)),
                  _createVNode(_component_PointNotation, {
                    "font-size": 24,
                    point: _ctx.usedPoints,
                    "sign-is-exists": false
                  }, null, 8, ["point"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.pointOver)
              ? (_openBlock(), _createBlock(_component_ValidationErrorText, { key: 1 }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" 合計送付ポイントが贈与可能ポイントを超えています。 ", -1)
                  ])),
                  _: 1,
                  __: [2]
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormLabel, {
              for: "send-point",
              required: true
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("送付ポイント", -1)
              ])),
              _: 1,
              __: [3]
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, { name: "sendPoint" }, {
                default: _withCtx(({ value, errorMessage, handleChange }) => [
                  (_ctx.pointTypeOf === 'free' || _ctx.pointTypeOf === 'availablePointRange')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_InputText, {
                            id: "send-point",
                            type: "text",
                            value: value,
                            onInput: event => {
                  handleChange(event);
                  _ctx.notifySendPoint(event);
                },
                            error: errorMessage,
                            placeholder: "100",
                            maxlength: 20
                          }, null, 8, ["value", "onInput", "error"])
                        ]),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.unit.point), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pointTypeOf === 'availablePointRange')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_SmallText, null, {
                          default: _withCtx(() => [
                            _cache[4] || (_cache[4] = _createTextVNode(" 送付可能ポイント数: ", -1)),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.addComma(_ctx.availablePointRange.min)) + " 〜 " + _toDisplayString(_ctx.addComma(_ctx.availablePointRange.max)) + " " + _toDisplayString(_ctx.unit.point), 1)
                          ]),
                          _: 1,
                          __: [4]
                        })
                      ]))
                    : (_ctx.pointTypeOf === 'object')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            (_ctx.selectPoint)
                              ? (_openBlock(), _createBlock(_component_InputSelect, {
                                  key: 0,
                                  id: "send-point",
                                  value: value,
                                  onInput: event => {handleChange(event); _ctx.notifySendPoint(event);},
                                  error: errorMessage,
                                  options: _ctx.selectPoint.options,
                                  "font-family": "roboto"
                                }, null, 8, ["value", "onInput", "error", "options"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.unit.point), 1)
                        ]))
                      : (_ctx.pointTypeOf === 'number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.addComma(_ctx.displayFixedPoint)), 1),
                              _createVNode(_component_InputText, {
                                id: "send-point",
                                type: "hidden",
                                value: value,
                                onInput: handleChange,
                                error: errorMessage,
                                placeholder: "100"
                              }, null, 8, ["value", "onInput", "error"])
                            ]),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.unit.point), 1)
                          ]))
                        : _createCommentVNode("", true),
                  _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(errorMessage), 1)
                    ]),
                    _: 2
                  }, 1536), [
                    [_vShow, errorMessage]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_FormLabel, {
              for: "title",
              required: true
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("タイトル", -1)
              ])),
              _: 1,
              __: [5]
            }),
            _createVNode(_component_Field, { name: "title" }, {
              default: _withCtx(({ value, errorMessage, handleChange }) => [
                (_ctx.titleEditEnabled)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      id: "title",
                      type: _ctx.titleEditEnabled ? 'text' : 'hidden',
                      value: value,
                      onInput: event => {
            handleChange(event);
            _ctx.onTitleChange(event);
          },
                      error: errorMessage,
                      placeholder: ""
                    }, null, 8, ["type", "value", "onInput", "error"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(value), 1)),
                (_ctx.titleEditEnabled)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, "全半角100文字以内"))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(errorMessage), 1)
                  ]),
                  _: 2
                }, 1536), [
                  [_vShow, errorMessage]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_FormLabel, {
              for: "message",
              required: true
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("本文", -1)
              ])),
              _: 1,
              __: [6]
            }),
            _createVNode(_component_Field, { name: "message" }, {
              default: _withCtx(({ value, errorMessage, handleChange }) => [
                _createVNode(_component_InputTextarea, {
                  id: "message",
                  value: value,
                  onInput: event => {
            handleChange(event);
            _ctx.onMessageChange(event);
          },
                  error: errorMessage,
                  "add-style": { height: `${280 / 16}rem` },
                  placeholder: _ctx.defaultMessage
                }, null, 8, ["value", "onInput", "error", "placeholder"]),
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "p-cmt" }, "全半角500文字以内", -1)),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(errorMessage), 1)
                  ]),
                  _: 2
                }, 1536), [
                  [_vShow, errorMessage]
                ])
              ]),
              _: 1,
              __: [7]
            })
          ]),
          _createElementVNode("input", {
            type: "hidden",
            name: "giving_type",
            value: _ctx.givingType
          }, null, 8, _hoisted_21),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_ButtonMain, {
                type: "submit",
                disabled: !(meta.valid && _ctx.canSubmit),
                style: _normalizeStyle(!(meta.valid && _ctx.canSubmit) ? { background: '#e0e0e0' } : { background: _ctx.colorCode })
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode(" 入力内容を確認する ", -1)
                ])),
                _: 2,
                __: [8]
              }, 1032, ["disabled", "style"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "initial-values", "onSubmit"]))
    : _createCommentVNode("", true)
}